var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BeoDivider is custom made Divider component.
 *
 * @author rajeev.k
 * @description This component is an extension of Divider tag (<Divider/>).
 * All properties of Divider tag (<Divider/>) can be used by this BeoDivider component.
 */
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
var BeoDivider = function (_a) {
    var ref = _a.ref, props = __rest(_a, ["ref"]);
    return (_jsx(Divider, __assign({ ref: ref }, props, { pt: {
            root: function (_a) {
                var props = _a.props;
                return ({
                    className: classNames('flex relative', // alignments.
                    {
                        'w-full my-5 mx-0 py-0 px-5 before:block before:left-0 before:absolute before:top-1/2 before:w-full before:border-t before:border-gray-300 before:dark:border-blue-900/40': props.layout == 'horizontal', // Padding and borders for horizontal layout.
                        'min-h-full mx-4 md:mx-5 py-5 before:block before:min-h-full before:absolute before:left-1/2 before:top-0 before:transform before:-translate-x-1/2 before:border-l before:border-gray-300 before:dark:border-blue-900/40': props.layout == 'vertical' // Padding and borders for vertical layout.
                    }, {
                        'before:border-solid': props.type == 'solid',
                        'before:border-dotted': props.type == 'dotted',
                        'before:border-dashed': props.type == 'dashed'
                    } // Border type condition.
                    )
                });
            },
        } })));
};
export default BeoDivider;
